import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import {
  getSideBarToggleValue,
  toggleSideBar,
} from '../../redux/slice/toggleSlice';
import { NavLink } from 'react-router-dom';
import { IsideBarMenuListData } from '../../interfaces/mainPage/I-sidebar';

interface ListsProps {
  showSideBar: boolean;
  sideBarMenuListData: IsideBarMenuListData[] | null;
  setSpAuth: React.Dispatch<React.SetStateAction<boolean>>;
}

const OPEN_SIDEBAR_MIN_W = 'min-w-[200px]';
const OPEN_SIDEBAR_W = 'w-[200px]';
const CLOSE_SIDEBAR_MIN_W = 'min-w-[50px]';
const CLOSE_SIDEBAR_W = 'w-[50px]';

const Lists = ({ showSideBar, sideBarMenuListData, setSpAuth }: ListsProps) => {
  const activeLink =
    'group flex gap-3 pl-5 items-center h-[2.25rem] cursor-pointer bg-[#e9f0f8] bg-opacity-90 rounded text-primary-default';
  const normalLink =
    'group flex gap-3 pl-5 items-center h-[2.25rem] cursor-pointer text-sideBarText hover:bg-[#e9f0f8] hover:rounded';

  const handleLogout = (t: string) => {
    if (t === '/sp/login') {
      sessionStorage.removeItem('spAuthKey');
      // setSpAuth(false);
    }
  };

  return (
    <div>
      {sideBarMenuListData &&
        sideBarMenuListData.map((d, i) => (
          <NavLink
            to={`${d.link}`}
            key={i}
            className={({ isActive }) => (isActive ? activeLink : normalLink)}
            onClick={() => handleLogout(d.link)}
          >
            <div className={`w-[1.125rem] h-[1.125rem]`}>{d.svgFile()}</div>
            <span className={`text-inherit truncate`}>{d.text}</span>
            {/* {!showSideBar && (
              <span className=" text-[#555] text-xs font-bold absolute z-20 translate-x-12 hidden group-hover:block bg-[#e9f0f8]">
                {d.text}
              </span>
            )} */}
          </NavLink>
        ))}
    </div>
  );
};

interface SideBarProps {
  sideBarMenuListData: IsideBarMenuListData[] | null;
  setSpAuth: React.Dispatch<React.SetStateAction<boolean>>;
  openSidebarByClick: boolean;
}
const SpSideBar = ({
  sideBarMenuListData,
  setSpAuth,
  openSidebarByClick,
}: SideBarProps) => {
  const showSideBar = useAppSelector(getSideBarToggleValue);
  const dispatch = useAppDispatch();

  const handleToggle = () => {
    dispatch(toggleSideBar());
  };
  return (
    <div
      onMouseEnter={() => {
        if (!showSideBar) {
          handleToggle();
        }
      }}
      onMouseLeave={() => {
        if (!openSidebarByClick && showSideBar) {
          handleToggle();
        }
      }}
      className={`bg-white px-[0.375rem] flex flex-col overflow-auto duration-500 overflow-x-hidden 
      ${showSideBar ? OPEN_SIDEBAR_MIN_W : CLOSE_SIDEBAR_MIN_W} ${
        showSideBar ? OPEN_SIDEBAR_W : CLOSE_SIDEBAR_W
      }`}
    >
      {/* 상단  */}
      {showSideBar ? (
        <div className="h-[4.5rem] flex items-center">
          <span
            className={`text-2xl text-[#555] font-bold ml-[1.125rem] truncate`}
          >
            유씨웨어
          </span>
        </div>
      ) : (
        <div className="h-[2rem]"></div>
      )}
      {/* 하단 리스트 */}
      <Lists
        showSideBar={showSideBar}
        sideBarMenuListData={sideBarMenuListData}
        setSpAuth={setSpAuth}
      />
    </div>
  );
};

export default SpSideBar;
